<template>
  <!-- 骨架屏 -->
  <div v-if="pageLoading" style="padding-top: 80px">
    <van-skeleton title :row="5" />
    <van-skeleton title :row="5" style="margin-top: 30px" />
  </div>
  <div v-else class="xib-return-gift">
    <div class="page-root">
      <ul class="side-tabs">
        <li class="side-tabs__item" @click="ruleVisible = true">
          <div>
            <div>活动</div>
            <div style="margin-top: 1px">规则</div>
          </div>
        </li>
        <li
          class="side-tabs__item"
          @click="$router.push({ name: 'xibReturnGiftCollectRecord' })"
        >
          <div>
            <div>领取</div>
            <div>记录</div>
          </div>
        </li>
      </ul>

      <div class="prize-section">
        <div class="prize-panel">
          <div class="prize-panel__title">以下实物权益中任选其一</div>
          <div class="prize-panel__grid">
            <div class="prize-panel__layout">
              <div
                v-for="item in prizeList"
                :key="item.id"
                class="prize-card"
                :class="{
                  'is-selected': selectedRightsType === item.id,
                  'is-sold-out': item.soldOut,
                  'is-stock-loading': stockLoading,
                }"
                :role="item.soldOut || stockLoading ? undefined : 'button'"
                :tabindex="item.soldOut || stockLoading ? -1 : 0"
                @click="selectPrize(item)"
                @keyup.enter="selectPrize(item)"
              >
                <div
                  v-if="!item.soldOut && !stockLoading"
                  class="prize-card__radio"
                  aria-hidden="true"
                >
                  <svg
                    class="prize-card__radio-svg"
                    viewBox="0 0 36 36"
                    xmlns="http://www.w3.org/2000/svg"
                    shape-rendering="geometricPrecision"
                  >
                    <circle
                      class="prize-card__radio-ring"
                      cx="18"
                      cy="18"
                      r="13"
                      :fill="
                        selectedRightsType === item.id
                          ? '#ffffff'
                          : 'rgba(255,255,255,0.96)'
                      "
                      stroke="#6341a8"
                      stroke-width="2"
                    />
                    <circle
                      v-if="selectedRightsType === item.id"
                      class="prize-card__radio-core"
                      cx="18"
                      cy="18"
                      r="6.5"
                      fill="#6341a8"
                    />
                  </svg>
                </div>
                <div class="prize-card-wrap">
                  <div class="prize-card__img-wrap">
                    <img :src="item.img" :alt="item.name" />
                  </div>
                  <div class="prize-card__name">{{ item.name }}</div>
                </div>
                <div v-if="item.soldOut" class="prize-card__sold-out">
                  <img
                    class="prize-card__sold-out-img"
                    :src="imgReceived"
                    alt="已领完"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="hasAvailablePrize" class="claim-wrap">
        <div class="claim-btn" @click="handleClaim">
          <span class="claim-btn__text">领取权益</span>
        </div>
      </div>
    </div>

    <ruleModal :visible="ruleVisible" @confirm="ruleVisible = false" />
    <resultModal
      :visible="resultVisible"
      :message="resultMessage"
      @confirm="resultVisible = false"
    />
  </div>
</template>

<script>
import ruleModal from "./components/ruleModal.vue";
import { preloadAllImages } from "./components/preloadImages.js";
import resultModal from "./components/resultModal.vue";
import { check, queryGoodsStock } from "@/api/xibReturnGift.js";

export default {
  name: "xibReturnGift",
  components: { ruleModal, resultModal },
  data() {
    return {
      pageLoading: true,
      stockLoading: true,
      ruleVisible: false,
      resultVisible: false,
      resultMessage: "",
      selectedRightsType: null,
      imgPrizePanel: require("@/assets/imgs/xibReturnGift/prize_panel_bg.png"),
      imgReceived: require("@/assets/imgs/xibReturnGift/received.png"),
      prizeList: [
        {
          id: "B",
          name: "乐扣保温杯",
          img: require("@/assets/imgs/xibReturnGift/gift_thermos.png"),
          soldOut: false,
        },
        {
          id: "A",
          name: "金龙鱼大米",
          img: require("@/assets/imgs/xibReturnGift/gift_rice.png"),
          soldOut: false,
        },
        {
          id: "C",
          name: "潘婷洗护套盒",
          img: require("@/assets/imgs/xibReturnGift/gift_pantene.png"),
          soldOut: false,
        },
      ],
    };
  },
  computed: {
    hasAvailablePrize() {
      return this.prizeList.some((item) => !item.soldOut);
    },
  },
  async mounted() {
    await Promise.all([preloadAllImages(), this.fetchGoodsStock()]);
    this.pageLoading = false;
  },
  methods: {
    async fetchGoodsStock() {
      try {
        const { code, data } = await queryGoodsStock({});
        if (code === 0 && data?.goodsStockList?.length) {
          const stockMap = Object.fromEntries(
            data?.goodsStockList.map((item) => [
              item.rightsCode,
              item.stockStatus,
            ]),
          );
          this.prizeList.forEach((prize) => {
            if (stockMap[prize.id] !== undefined) {
              prize.soldOut = stockMap[prize.id] === 0;
            }
          });
        }
      } finally {
        this.stockLoading = false;
      }
    },
    selectPrize(item) {
      if (this.stockLoading || item.soldOut) return;
      this.selectedRightsType = item.id;
    },
    async handleClaim() {
      // 1: 领取时间未开始 2: 用户暂不符合领取资格 3: 未选择礼品 4: 用户已领取过权益
      // 获取当前北京时间
      const now = new Date();
      // 北京时间 = UTC时间 + 8小时
      const beijingOffset = 8 * 60; // 单位为分钟
      const localOffset = now.getTimezoneOffset();
      const beijingTime = new Date(
        now.getTime() + (beijingOffset + localOffset) * 60000,
      );

      // 比较时间是否早于2026-04-05 00:00:00(北京时间)
      const limitTime = new Date("2026-04-20T00:00:00+08:00");

      // if (beijingTime < limitTime) {
      //   this.resultMessage = "领取时间未开始";
      //   this.resultVisible = true;
      //   return;
      // }

      if (!this.selectedRightsType) {
        this.resultMessage = "请选择其中一个商品领取";
        this.resultVisible = true;
        return;
      }

      const { code, message } = await check({});
      if (code === 0) {
        this.$router.push({
          name: "xibReturnGiftAddressForm",
          query: { rightsType: this.selectedRightsType },
        });
      } else {
        this.resultMessage = message;
        this.resultVisible = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.xib-return-gift {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-color: #726ac4;

  .page-root {
    position: relative;
    width: 100%;
    min-height: 100vh;
    margin: 0 auto;
    background: url("~@/assets/imgs/xibReturnGift/bg_page.png");
    background-size: 100%;
    background-repeat: no-repeat;
  }

  .side-tabs {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
    box-sizing: border-box;
    padding-top: 277px;
    padding-right: 16px;
    padding-left: 0;
    margin: 0;
    list-style: none;
    gap: 10px;

    .side-tabs__item {
      width: 50px;
      height: 50px;
      border-radius: 8px;
      border: 1px solid #ffeec0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 13px;
      font-weight: 500;
      background-color: rgba(115, 80, 193, 0.6);
      letter-spacing: 1px;
    }
  }

  .prize-section {
    padding-top: 22px;
    width: 100%;
    max-width: 690px;
    pointer-events: auto;
    margin: 0 auto;

    .prize-panel {
      position: relative;
      width: 100%;
      height: 250px;
      background: url("~@/assets/imgs/xibReturnGift/prize_panel_bg.png")
        no-repeat top center;
      background-size: 100% 100%;
      position: relative;

      .prize-panel__title {
        text-align: center;
        font-size: 18px;
        color: #ffeec0;
        height: 38px;
        position: absolute;
        top: 22px;
        width: 100%;
        line-height: 38px;
      }

      .prize-panel__grid {
        width: 100vw;
        padding-left: 29px;
        padding-right: 29px;
        position: absolute;
        top: 75px;
        box-sizing: border-box;

        .prize-panel__layout {
          display: flex;
          height: 126px;
          width: 100%;
          justify-content: space-between;
          gap: 6px;
          border-radius: 8px;
          overflow: hidden;

          .prize-card {
            position: relative;
            width: 100%;
            background: linear-gradient(0deg, #d2c7ff, #ffffff, #cfccff);
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            box-sizing: border-box;

            /* SVG 矢量圆：不依赖 border-radius / flex，避免 WebView 下椭圆 */
            .prize-card__radio {
              position: absolute;
              top: 4px;
              right: 4px;
              z-index: 2;
              width: 20px;
              height: 20px;
              line-height: 0;
              pointer-events: none;
            }

            .prize-card__radio-svg {
              display: block;
              width: 20px;
              height: 20px;
            }

            &.is-sold-out,
            &.is-stock-loading {
              cursor: not-allowed;
            }

            .prize-card__sold-out {
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: rgba(0, 1, 13, 0.5);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 1;
            }

            .prize-card__sold-out-img {
              width: 58px;
              height: auto;
              object-fit: contain;
            }

            .prize-card-wrap {
              .prize-card__img-wrap {
                img {
                  height: 88px;
                  object-fit: contain;
                }
              }

              .prize-card__name {
                height: 17px;
                width: 70px;
                border-radius: 17px;
                border: 1px solid #3f246b;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                color: #3f246b;
                margin-top: 5px;
              }
            }
          }
        }
      }
    }
  }

  .claim-wrap {
    display: flex;
    justify-content: center;
    pointer-events: auto;
    padding: 0 24px;
    padding-bottom: 20px;
    box-sizing: border-box;

    .claim-btn {
      width: 180px;
      height: 75px;
      background: url("~@/assets/imgs/xibReturnGift/btn_claim_bg.png") no-repeat
        center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      .claim-btn__text {
        font-size: 23px;
        font-weight: 400;
        color: #ffeec0;
      }
    }
  }
}
</style>
